module.exports = __webpack_public_path__ + "img/slider_1.882c35c8.png";